<app-label-inflator
  #labelCalculator
  hidden
  class="label-calculator"
  [calculateVirtualLabel]="true"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>
<div class="glass-house-3-x-4-card" [class.has-label]="labelCalculator.hasLabelText$ | push: 'immediate'">
  <app-glass-house-brand-logo [data]="data" />
  <app-glass-house-variant-type-and-label
    [data]="data"
    [hasLabelText]="labelCalculator.hasLabelText$ | push: 'immediate'"
    [viewingInLiveView]="viewModel.viewingInLiveView$ | push: 'immediate'" />
  <app-glass-house-description [data]="data" />
  <app-glass-house-header-quantity-and-price />
  <app-glass-house-quantity-and-price
    [data]="data"
    [parentViewModel]="viewModel"
    [cappedSpoofedGridColViewModels]="viewModel.cappedSpoofedGridColViewModels$ | push: 'immediate'"
    [plusNMoreCols]="0" />
</div>
